import { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import BonUrbaLogo from '../../assets/icons/BonUrbaLogo'

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollTo = (id) => (e) => {
    e.preventDefault()
    setMenuOpen(false)
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } })
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 bg-white/[0.92] backdrop-blur-xl border-b border-gray-200 transition-shadow duration-300 ${scrolled ? 'shadow-md' : ''}`}>
      <div className="max-w-[1200px] mx-auto px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center no-underline">
          <BonUrbaLogo height={44} />
        </Link>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className={`block w-5 h-0.5 bg-gray-700 transition-transform ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-0.5 bg-gray-700 transition-opacity ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-gray-700 transition-transform ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8 list-none">
          <li>
            <a href="#fonctionnalites" onClick={scrollTo('fonctionnalites')} className="text-sm font-medium text-gray-600 hover:text-green-600 transition-colors no-underline">
              Fonctionnalités
            </a>
          </li>
          <li>
            <a href="#tarifs" onClick={scrollTo('tarifs')} className="text-sm font-medium text-gray-600 hover:text-green-600 transition-colors no-underline">
              Tarifs
            </a>
          </li>
          <li>
            <Link to="/guides" className="text-sm font-medium text-gray-600 hover:text-green-600 transition-colors no-underline">
              Guides
            </Link>
          </li>
          <li>
            <Link to="/app" className="inline-flex items-center gap-2 px-5 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 hover:-translate-y-px hover:shadow-md transition-all no-underline">
              Accéder gratuitement
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
          </li>
        </ul>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white px-6 py-4 flex flex-col gap-4">
          <a href="#fonctionnalites" onClick={scrollTo('fonctionnalites')} className="text-sm font-medium text-gray-600 no-underline">
            Fonctionnalités
          </a>
          <a href="#tarifs" onClick={scrollTo('tarifs')} className="text-sm font-medium text-gray-600 no-underline">
            Tarifs
          </a>
          <Link to="/guides" onClick={() => setMenuOpen(false)} className="text-sm font-medium text-gray-600 no-underline">
            Guides
          </Link>
          <Link to="/app" onClick={() => setMenuOpen(false)} className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-green-600 text-white text-sm font-semibold rounded-lg no-underline">
            Accéder gratuitement
          </Link>
        </div>
      )}
    </nav>
  )
}
